import { FC, memo, useMemo } from 'react'

import { LIMIT_FOR_UNREAD_DISPLAY_COUNT } from 'configs/constants'
import { useAppSelector } from 'states/hooks'
import { CrewCountBadge } from 'components/crewCountBadge/crewCountBadge'

export const CrewAnnouncementUnreadBadge: FC = memo(() => {
  const announcementUnreadCount = useAppSelector(
    (state) => state.announcement.unreadCount
  )

  // if unread number is greater than 99, display 99+
  const counterText =
    announcementUnreadCount > LIMIT_FOR_UNREAD_DISPLAY_COUNT
      ? `${LIMIT_FOR_UNREAD_DISPLAY_COUNT}+`
      : `${announcementUnreadCount}`

  const targetBackgroundClassNames = useMemo(
    () => (announcementUnreadCount > 0 ? 'crew-badge-red-inverted' : ''),
    [announcementUnreadCount]
  )

  if (announcementUnreadCount <= 0) {
    // 未読0なら何も表示しない
    return null
  }

  return (
    <CrewCountBadge displayColor={targetBackgroundClassNames}>
      {counterText}
    </CrewCountBadge>
  )
})
